import { createContext, useContext, type ReactNode } from 'react';
import type { ContextMenuItem } from '@/components/ui/ContextMenu/ContextMenu';

export interface CommentBadgeInfo {
  count: number;
  onOpen: (e: React.MouseEvent) => void;
  onPointerEnter: () => void;
  onPointerLeave: () => void;
}

export interface CellCommentShellContextValue {
  addCommentMenuItem: ContextMenuItem;
  /** Если передан — бейдж комментариев рендерится внутри дочернего компонента (SessionBubbleCore), а не в shell. */
  commentBadge: CommentBadgeInfo | null;
}

export const CellCommentShellContext = createContext<CellCommentShellContextValue | null>(null);

export function useCellCommentShellOptional(): CellCommentShellContextValue | null {
  return useContext(CellCommentShellContext);
}

export function CellCommentShellProvider({
  value,
  children,
}: {
  value: CellCommentShellContextValue;
  children: ReactNode;
}) {
  return <CellCommentShellContext.Provider value={value}>{children}</CellCommentShellContext.Provider>;
}
